import { Row, Col, Card, Space, Divider, Descriptions, Radio, Tabs, Button, Typography } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import FurnishingErrorModal from './FurnishingErrorModal';
import AccountDetails from './FurnishingComponents/AccountDetails';
import useFurnishingChanges from './FurnishingComponents/useFurnishingChanges';
import usePageState from '../../../helpers/usePageState';

function FurnishingComponent({
  bloomFurnishing = {},
  creditCards = {},
  userId,
  userSummary,
  refresh
}) {
  const titleStyle = {
    color: "white",
    backgroundColor: "#a448ff",
    padding: 15,
    borderRadius: 5,
    position: 'sticky',
    top: 0,
    zIndex: 1
  };

  const [accountTypeFilter, setAccountTypeFilter] = usePageState('furnishing-account-type', 'cc');

  const [savedCcTab, setCcTabSelection] = usePageState('furnishing-cc-account', null);
  const [savedSbTab, setSbTabSelection] = usePageState('furnishing-sb-account', null);

  const { furnishingChanges, loading, getFurnishingChanges } = useFurnishingChanges({ userId });
  const creditCardFurnishingAccounts = bloomFurnishing?.creditCardFurnishingAccounts;
  const savingsBuilderFurnishingAccounts = bloomFurnishing?.savingsBuilderFurnishingAccounts || [];
  
  const fullName = `${userSummary?.firstName} ${userSummary?.lastName}`;

  const CCTabsList = [];
  const CCTabsContent= {};

  if (creditCardFurnishingAccounts && creditCardFurnishingAccounts.length > 0) {
    creditCardFurnishingAccounts.forEach((_ccData, _i) => {
      CCTabsList.push({
        key: _ccData.accountId,
        tab: <div style={{textAlign: 'center'}}>{_ccData.openDate}<br/><small style={{fontSize: '50%'}}>({_ccData.accountStatus})</small></div>,
      })
      CCTabsContent[_ccData.accountId] = (
        <AccountDetails
          key={_i}
          fullName={fullName}
          account={_ccData}
          isCC={true}
          refresh={refresh}
          creditCards={creditCards}
          userId={userId}/>
      );
    });
  };

  const ccTabSelection = CCTabsContent[savedCcTab] ? savedCcTab : CCTabsList[0]?.key;

  const SBTabsList = [];
  const SBTabsContent= {};

  if (savingsBuilderFurnishingAccounts && savingsBuilderFurnishingAccounts.length > 0) {
    savingsBuilderFurnishingAccounts.forEach((_sbData, _i) => {
      SBTabsList.push({
        key: _sbData.accountId,
        tab: <div style={{textAlign: 'center'}}>{_sbData.openDate}<br/><small style={{fontSize: '50%'}}>({_sbData.accountStatus})</small></div>,
      })
      SBTabsContent[_sbData.accountId] = (
        <AccountDetails
          key={_i}
          fullName={fullName}
          account={_sbData}
          isCC={false}
          refresh={refresh}
          creditCards={creditCards}
          userId={userId}/>
      );
    });
  };

  const sbTabSelection = SBTabsContent[savedSbTab] ? savedSbTab : SBTabsList[0]?.key;

  return (
    <Card
      bordered={true}
      className="criclebox tablespace mb-16 card-cancel-subscription"
    >
      <Row className="subscription-cancelled-card" gutter={[30, 30]} style={{textAlign: "center"}}>
        <Col span={6}>
          <Radio.Group value={accountTypeFilter} buttonStyle="solid" size="large">
            <Radio.Button
              onChange={() => setAccountTypeFilter('cc')}
              value="cc">
                Credit Card <small>({creditCardFurnishingAccounts?.length ?? 0})</small>
            </Radio.Button>
            <Radio.Button
              onChange={() => setAccountTypeFilter('sb')}
              value="sb">
                S&B <small>({savingsBuilderFurnishingAccounts?.length ?? 0})</small>
            </Radio.Button>
            {/* <Radio.Button
              onChange={() => setAccountTypeFilter(null)}
              >x <small>&nbsp;</small>
            </Radio.Button> */}
          </Radio.Group>
        </Col>
        <Col span={14}>
          &nbsp;
        </Col>
        <Col span={4}>
          <Space align='left'>
            <Button type="primary" ghost icon={<SyncOutlined />} onClick={refresh}>Refresh</Button>
            <FurnishingErrorModal />
          </Space>
        </Col>
      </Row>
      {/* Credit Card */}
      {(!accountTypeFilter || accountTypeFilter === 'cc') && <>
        <Card
          title="Credit Cards"
          tabList={CCTabsList}
          activeTabKey={ccTabSelection}
          onTabChange={(key) => setCcTabSelection(key)}
        >
        {(CCTabsList.length > 0) ?
            CCTabsContent[ccTabSelection] :
          <Row className="no-data-card">No data found</Row>}
        </Card>
      <Row >&nbsp;</Row>
      <Divider />
      </>}
      {/* Saving Builder */}
      {(!accountTypeFilter || accountTypeFilter === 'sb') && <>
        <Card
          title="Savings Builder"
          tabList={SBTabsList}
          activeTabKey={sbTabSelection}
          onTabChange={(key) => setSbTabSelection(key)}
        >
        {(SBTabsList.length > 0) ?
            SBTabsContent[sbTabSelection] :
          <Row className="no-data-card">No data found</Row>}
        </Card>
      <Row >&nbsp;</Row>
      <Divider />
      </>}
    </Card>
  );
}

export default FurnishingComponent;